import {Storage} from '../__Storage';

export const sessionStorage = new Storage('sessionStorage');
